/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { agentSchedulesPauseAgentSchedule } from "../../funcs/agentSchedulesPauseAgentSchedule.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.PauseAgentScheduleRequest$inboundSchema,
};

export const tool$agentSchedulesPauseAgentSchedule: ToolDefinition<
  typeof args
> = {
  name: "agent-schedules-pause-agent-schedule",
  description: `Pause an agent schedule`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await agentSchedulesPauseAgentSchedule(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
